import { Download, Search, Sparkles } from 'lucide-react'
import SiteHeader from './SiteHeader'
import CuratedFeed from './home/CuratedFeed'

const APP_STORE_URL = 'https://apps.apple.com/gb/app/bukito/id6756301072'

// Dedicated browse page: all curated lists as flat rows (mobile-app style).
const BrowseLists = () => (
  <div className="min-h-screen bg-bg-main">
    <SiteHeader />

    <section className="border-b border-primary-100 bg-primary-50">
      <div className="container-custom py-12 lg:py-16">
        <div className="grid gap-8 lg:grid-cols-[1fr_360px] lg:items-end">
          <div>
            <div className="mb-4 inline-flex items-center gap-2 rounded-lg bg-bg-surface px-3 py-2 text-sm font-bold text-primary-700 shadow-soft">
              <Sparkles size={17} />
              Parent-friendly book discovery
            </div>
            <h1 className="max-w-3xl text-4xl font-extrabold leading-tight text-text-primary sm:text-5xl lg:text-6xl">
              Find the next book without starting from a blank search box.
            </h1>
            <p className="mt-5 max-w-2xl text-lg leading-relaxed text-text-secondary">
              Browse Bukito&apos;s curated lists for children aged 0-8, from sturdy first books to confident early readers.
            </p>
          </div>

          <div className="hidden rounded-lg border border-primary-100 bg-bg-surface p-5 shadow-soft lg:block">
            <div className="flex items-start gap-3">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-yellow-500 text-text-primary">
                <Search size={20} />
              </span>
              <div>
                <h2 className="text-lg font-extrabold text-text-primary">Save and track in the app</h2>
                <p className="mt-1 text-sm leading-relaxed text-text-secondary">
                  Use the website to explore, then keep favourites, reading progress and family lists together in Bukito.
                </p>
              </div>
            </div>
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex h-11 w-full items-center justify-center gap-2 rounded-lg bg-primary-500 px-4 text-sm font-bold text-white shadow-button transition-colors hover:bg-primary-600"
            >
              <Download size={17} />
              Download Bukito
            </a>
          </div>
        </div>
      </div>
    </section>

    <CuratedFeed header="none" showPanel />
  </div>
)

export default BrowseLists
